import { render, staticRenderFns } from "./LpProdOptionStocks.vue?vue&type=template&id=f14bf810&scoped=true"
import script from "./LpProdOptionStocks.vue?vue&type=script&lang=js"
export * from "./LpProdOptionStocks.vue?vue&type=script&lang=js"
import style0 from "./LpProdOptionStocks.vue?vue&type=style&index=0&id=f14bf810&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14bf810",
  null
  
)

export default component.exports